import React, { lazy, Suspense } from 'react';
import Loading from '@/app/components/Loading';

const hoc = function(WrapLazy) {
  return function(props) {
    return function() {
      return (
        <Suspense fallback={<Loading />}>
          <WrapLazy {...props} />
        </Suspense>
      );
    };
  };
};

const Aside = lazy(() => import('../common/Aside'));
const [S_Aside] = [hoc(Aside)];

export { S_Aside };
